class MultiColumnSwiper extends HTMLElement {
  constructor() {
    super();
    this.Init();
  }

  Init() {
    let swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: parseFloat(this.dataset.slides_per_row_mobile),
      spaceBetween: 0,
      navigation: {
        prevEl: this.querySelector('.prev-next-button--prev'),
        nextEl: this.querySelector('.prev-next-button--next'),
      },
      on: {
        init: this.Update.bind(this),
        resize: this.Update.bind(this),
      },
      breakpoints: {
        768: {
          slidesPerView: parseFloat(this.dataset.slides_per_row_mobile) * 2,
        },
        1024: {
          slidesPerView: parseFloat(this.dataset.slides_per_row_mobile) * 1.5,
          slidesPerGroup: 3,
        },
        1280: {
          slidesPerView: parseFloat(this.dataset.slides_per_row),
          slidesPerGroup: 3
        }
      }
    });
  }

  Update() {
    let slides_per_row_mobile = parseFloat(this.dataset.slides_per_row_mobile);
    let slides_per_row = parseFloat(this.dataset.slides_per_row);
    let is_mobile = window.matchMedia('(max-width: 767px)').matches;
    let is_tablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
    let is_desktop = window.matchMedia('(min-width: 1280px)').matches;

    let slides_count = this.querySelectorAll('.swiper-slide').length;

    if (is_mobile) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row_mobile);
    }
    if (is_tablet) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row_mobile * 2);
    }
    if (is_desktop) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row);
    }
  }
}
customElements.define('multi-column-swiper', MultiColumnSwiper);

const u_debounce = (fn, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

if (!customElements.get('surfboard-variants')) {
  class SurfboardVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.model = this.dataset.model;
      if (!this.model) return;

      this.LoadSurfboards();
    }

    async LoadSurfboards() {
      let url = `/collections/all?filter.p.m.surfboard.model=${this.model}&section_id=dac-api-surfboard-variants&ts=${Date.now()}`;
      let res = await fetch(encodeURI(url));
      let html = await res.text();
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');

      let picker = doc.querySelector('surfboard-picker');
      if (!picker) {
        console.error('surfboard-picker not found');
        return;
      }

      this.innerHTML = '';
      this.appendChild(picker);

      this.InitEventHandlers();
      this.TriggerInitialOption();
    }

    InitEventHandlers() {
      let $selected = this.querySelector('#popover-surboards-selected-value');
      let section_id = this.dataset.sectionId;

      this.querySelectorAll('.popover__value-option').forEach(option => {
        option.addEventListener(
          'click',
          u_debounce(() => {
            if (option.dataset.available === 'false') {
              return;
            }

            const product_handle = option.dataset.productHandle;
            const length = option.dataset.length;

            if (!product_handle) {
              console.error('Product not found');
              return;
            }

            if (this.OptionHasUsefulMetafields(option)) {
              this.RenderFromOption(option);
            }

            if (product_handle === this.dataset.currentProductHandle) {
              let popover = this.querySelector('x-popover');
              if (popover) {
                popover.hide();
              }
              return;
            }

            this.dataset.currentProductHandle = product_handle;

            let input = option.querySelector('input');
            if ($selected && input) {
              $selected.textContent = input.value;
            }

            this.LoadProduct(product_handle, length, section_id);
          }, 300)
        );
      });
    }

    TriggerInitialOption() {
      let selectedOption =
        this.querySelector('.popover__value-option input:checked[data-available="true"]')?.closest('.popover__value-option') ||
        this.querySelector('.popover__value-option[data-available="true"]') ||
        this.querySelector('.popover__value-option input:checked')?.closest('.popover__value-option') ||
        this.querySelector('.popover__value-option');

      if (!selectedOption) {
        console.error('No initial surfboard option found');
        return;
      }

      if (selectedOption.dataset.available === 'false') {
        console.error('Initial option is unavailable');
        return;
      }

      const product_handle = selectedOption.dataset.productHandle;
      const length = selectedOption.dataset.length;
      const section_id = this.dataset.sectionId;

      if (!product_handle) {
        console.error('Initial product handle not found');
        return;
      }

      if (this.OptionHasUsefulMetafields(selectedOption)) {
        this.RenderFromOption(selectedOption);
      }

      this.dataset.currentProductHandle = product_handle;

      let input = selectedOption.querySelector('input');
      let selectedLabel = this.querySelector('#popover-surboards-selected-value');

      if (input && selectedLabel) {
        selectedLabel.textContent = input.value;
      }

      this.LoadProduct(product_handle, length, section_id);
    }

    RenderFromOption(option) {
      if (!option) return;

      let surfboardMetafields = {
        model: option.dataset.model || '',
        tail_shape: option.dataset.tailShape || '',
        length_in: option.dataset.lengthIn || '',
        width_in: option.dataset.widthIn || '',
        thickness_in: option.dataset.thicknessIn || '',
        volume: option.dataset.volume || '',
        type: option.dataset.type || '',
        length: option.dataset.lengthLabel || '',
        id_surfboardmodel: option.dataset.idSurfboardmodel || '',
        id_warehouse: option.dataset.idWarehouse || '',
        construction_type: option.dataset.constructionType || '',
        stocktype: option.dataset.stocktype || ''
      };

      this.RenderSizeSummary(surfboardMetafields);

      const metafieldsMap = this.BuildMetafieldsMapFromOption(option);
      this.UpdateTechSpecs(metafieldsMap);
    }

    BuildMetafieldsMapFromOption(option) {
      return {
        'surfboard.model': option.dataset.model || '',
        'surfboard.tail_shape': option.dataset.tailShape || '',
        'surfboard.length_in': option.dataset.lengthIn || '',
        'surfboard.width_in': option.dataset.widthIn || '',
        'surfboard.thickness_in': option.dataset.thicknessIn || '',
        'surfboard.volume': option.dataset.volume || '',
        'surfboard.type': option.dataset.type || '',
        'surfboard.length': option.dataset.lengthLabel || '',
        'surfboard.id_surfboardmodel': option.dataset.idSurfboardmodel || '',
        'surfboard.id_warehouse': option.dataset.idWarehouse || '',
        'surfboard.construction_type': option.dataset.constructionType || '',
        'surfboard.stocktype': option.dataset.stocktype || ''
      };
    }

    UpdateTechSpecs(metafieldsMap) {
      document.querySelectorAll('[data-tech-mf-key]').forEach(el => {
        const key = (el.dataset.techMfKey || '').trim();
        if (!key) return;

        const incomingValue = metafieldsMap[key];

        if (typeof incomingValue === 'undefined') return;
        if (incomingValue === null || incomingValue === '') return;

        el.textContent = incomingValue;
      });
    }

    RenderSizeSummary(surfboardMetafields) {
      let sizeRowEl = document.querySelector('[data-surfboard-size-row]');
      let sizeSummaryEl = document.querySelector('[data-surfboard-field="size-summary"]');

      if (!sizeRowEl || !sizeSummaryEl) return;

      const hasSizeData =
        surfboardMetafields.length_in ||
        surfboardMetafields.width_in ||
        surfboardMetafields.thickness_in ||
        surfboardMetafields.volume;

      if (!hasSizeData) {
        sizeSummaryEl.textContent = '';
        sizeRowEl.style.display = 'none';
        return;
      }

      sizeSummaryEl.textContent = `${surfboardMetafields.length_in} X ${surfboardMetafields.width_in} X ${surfboardMetafields.thickness_in} - ${surfboardMetafields.volume}L`;
      sizeRowEl.style.display = '';
    }

    async LoadProduct(product_handle, length, section_id) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            current_surfboard_length: length || null
          }
        })
      });

      let url = `/products/${product_handle}?section_id=${section_id}&ts=${Date.now()}`;
      let res = await fetch(url);
      let html = await res.text();
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');

      let $new_product = doc.querySelector('product-rerender .product');
      let metafieldsEl = doc.querySelector('.surfboard-metafields-data');

      const hasUsefulMetafields =
        metafieldsEl &&
        (
          metafieldsEl.dataset.model ||
          metafieldsEl.dataset.tailShape ||
          metafieldsEl.dataset.lengthIn ||
          metafieldsEl.dataset.widthIn ||
          metafieldsEl.dataset.thicknessIn ||
          metafieldsEl.dataset.volume ||
          metafieldsEl.dataset.type ||
          metafieldsEl.dataset.length ||
          metafieldsEl.dataset.idSurfboardmodel ||
          metafieldsEl.dataset.idWarehouse ||
          metafieldsEl.dataset.constructionType ||
          metafieldsEl.dataset.stocktype
        );

      if (!hasUsefulMetafields) {
        metafieldsEl = null;
      }

      if (metafieldsEl) {
        let surfboardMetafields = {
          model: metafieldsEl.dataset.model || '',
          tail_shape: metafieldsEl.dataset.tailShape || '',
          length_in: metafieldsEl.dataset.lengthIn || '',
          width_in: metafieldsEl.dataset.widthIn || '',
          thickness_in: metafieldsEl.dataset.thicknessIn || '',
          volume: metafieldsEl.dataset.volume || '',
          type: metafieldsEl.dataset.type || '',
          length: metafieldsEl.dataset.length || '',
          id_surfboardmodel: metafieldsEl.dataset.idSurfboardmodel || '',
          id_warehouse: metafieldsEl.dataset.idWarehouse || '',
          construction_type: metafieldsEl.dataset.constructionType || '',
          stocktype: metafieldsEl.dataset.stocktype || ''
        };

        this.RenderSizeSummary(surfboardMetafields);

        const metafieldsMap = {
          'surfboard.model': metafieldsEl.dataset.model || '',
          'surfboard.tail_shape': metafieldsEl.dataset.tailShape || '',
          'surfboard.length_in': metafieldsEl.dataset.lengthIn || '',
          'surfboard.width_in': metafieldsEl.dataset.widthIn || '',
          'surfboard.thickness_in': metafieldsEl.dataset.thicknessIn || '',
          'surfboard.volume': metafieldsEl.dataset.volume || '',
          'surfboard.type': metafieldsEl.dataset.type || '',
          'surfboard.length': metafieldsEl.dataset.length || '',
          'surfboard.id_surfboardmodel': metafieldsEl.dataset.idSurfboardmodel || '',
          'surfboard.id_warehouse': metafieldsEl.dataset.idWarehouse || '',
          'surfboard.construction_type': metafieldsEl.dataset.constructionType || '',
          'surfboard.stocktype': metafieldsEl.dataset.stocktype || ''
        };

        this.UpdateTechSpecs(metafieldsMap);
      }

      let $current_product = this.closest('.product');

      if ($new_product && $current_product) {
        let $new_gallery = $new_product.querySelector('.product__gallery');
        let $current_gallery = $current_product.querySelector('.product__gallery');

        if ($new_gallery && $current_gallery) {
          $current_gallery.replaceWith($new_gallery);
        }

        let blocks_to_replace = [
          'text',
          'quantity-selector',
          'variant-picker',
          'buy-buttons',
          'sku',
          'price',
          'vendor',
          'description'
        ];

        blocks_to_replace.forEach(block_type => {
          let $current_block = $current_product.querySelector(`[data-block-type="${block_type}"]`);
          let $new_block = $new_product.querySelector(`[data-block-type="${block_type}"]`);

          if ($new_block && $current_block) {
            $current_block.replaceWith($new_block);
          }
        });
      }

      if (window.location.pathname.includes('/products/')) {
        this.UpdateUrlHistory(product_handle);
      }
    }

    OptionHasUsefulMetafields(option) {
      if (!option) return false;

      return !!(
        option.dataset.model ||
        option.dataset.tailShape ||
        option.dataset.lengthIn ||
        option.dataset.widthIn ||
        option.dataset.thicknessIn ||
        option.dataset.volume ||
        option.dataset.type ||
        option.dataset.lengthLabel ||
        option.dataset.idSurfboardmodel ||
        option.dataset.idWarehouse ||
        option.dataset.constructionType ||
        option.dataset.stocktype
      );
    }

    UpdateUrlHistory(product_handle) {
      let url_params = new URLSearchParams(window.location.search);
      let newurl = `${window.location.protocol}//${window.location.host}/products/${product_handle}`;

      if (url_params.toString() !== '') {
        newurl += `?${url_params.toString()}`;
      }

      window.history.replaceState({ path: newurl }, '', newurl);
    }
  }

  customElements.define('surfboard-variants', SurfboardVariants);
}